var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"position":"absolute","top":"-500px","right":"-500px"},attrs:{"src":_vm.pixelUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }